import { MainImages } from '@lemon/assets';
import { headers } from '../../layout/header/Header';

export const Pouch = () => {
    return (
        <figure
            id={headers[3].id}
            className="relative w-full h-full flex flex-col items-center text-center justify-center bg-white text-black pt-[230px] px-4"
        >
            <div className="w-full max-w-[1200px] mx-auto flex flex-col items-center gap-6 md:gap-10">
                <div className="text-[60px] md:text-[100px] lg:text-[120px] font-bold text-balance">
                    {title}
                </div>

                <div className="text-[14px] md:text-[18px] lg:text-[20px] text-black/60 text-pretty leading-relaxed max-w-[800px]">
                    {description1_1}
                    <br className="md:hidden" />
                    <span className="hidden md:inline"> </span>
                    {description1_2}
                </div>

                <div className="text-[14px] md:text-[18px] lg:text-[20px] text-black/60 text-pretty leading-relaxed max-w-[900px]">
                    {description2_1} {description2_2} {description2_3} {description2_4}
                </div>
            </div>

            <img
                src={MainImages.pouch_content}
                alt="pouch"
                onDragStart={e => e.preventDefault()}
                className="w-full max-w-[1200px] mt-10 md:mt-16"
            />
        </figure>
    );
};

const title = 'pouch';
const description1_1 = 'EPYT는 화장품 파우치 속 제품 데이터를 수집하여,';
const description1_2 = '개인의 특성·취향·구매행동 간 상관관계를 정량적으로 분석합니다.';

const description2_1 = '이를 바탕으로 소비자가 실제 사용하는 제품 조합에서 얻은 인사이트를 도출하며,';
const description2_2 = 'EPYT만의 알고리즘으로 세분화된 사용자 군집을 정의해 더욱 정확한';
const description2_3 = '타깃 세그멘테이션을 수행합니다. 마지막으로, 분석 결과를 기반으로 사용자';
const description2_4 = '개개인에게 최적화된 개인화 큐레이션을 제공합니다.';
